<template>
  <span v-if="start || end" :class="`badge ${badgeStatus}`">
    {{ displayPeriod }}
  </span>
</template>

<script>
import moment from "moment";

export default {
  props: {
    start: {
      type: String,
      default: null,
    },

    end: {
      type: String,
      default: null,
    },
  },

  computed: {
    displayPeriod() {
      if (this.start && this.end) {
        return `Du ${this.formatDate(this.start)} au ${this.formatDate(
          this.end
        )}`;
      }

      if (this.start) {
        return `À partir du ${this.formatDate(this.start)}`;
      }

      if (this.end) {
        return `Jusqu'au ${this.formatDate(this.end)}`;
      }

      return "Aucune période définie";
    },

    badgeStatus() {
      if (this.start && this.end) {
        if (
          moment().isBetween(
            moment(this.start).startOf("d"),
            moment(this.end).endOf("d")
          )
        ) {
          return "badge-success";
        }

        return moment().isBefore(moment(this.start).startOf("d"))
          ? "badge-info"
          : "badge-danger";
      }

      if (this.start) {
        return moment().isAfter(moment(this.start).startOf("d"))
          ? "badge-success"
          : "badge-info";
      }

      if (this.end) {
        return moment().isBefore(moment(this.end).endOf("d"))
          ? "badge-success"
          : "badge-danger";
      }

      return "badge-info";
    },
  },
};
</script>
